import { CRS } from "./CRS";
import key from "url:../../../assets/cursors/KeyCursor-gold.png";

export function KY1 () {
    return <CRS>
        <img src={key} className='mcs-icon' />
    </CRS>
}